import type { YachtDice, YachtHeldDice } from "@cloudnest/yacht-engine";
import { DieButton } from "./DieButton";

export function DiceTray({
  dice,
  held,
  holdableDice,
  readOnly,
  onToggleHold,
}: {
  readonly dice: YachtDice;
  readonly held: YachtHeldDice;
  readonly holdableDice: readonly number[];
  readonly readOnly: boolean;
  readonly onToggleHold: (dieIndex: number) => void;
}) {
  return (
    <div className="yacht-dice-tray" data-testid="yacht-dice-tray">
      {dice.map((die, index) => (
        <DieButton
          die={die}
          disabled={readOnly || !holdableDice.includes(index)}
          held={held[index] ?? false}
          key={index}
          onToggle={() => onToggleHold(index)}
        />
      ))}
    </div>
  );
}
